export enum AvailableThemes{
  Red= 'red_theme',
  Green= 'green_theme',
  Gold= '',
  Grey= 'dark_grey',
  Dark= 'dark_mode'

}
